import Helmet from 'react-helmet'
import React from 'react'

const RecaptchaScripts = () => (
  <Helmet>
    <script
      src={`https://www.google.com/recaptcha/enterprise.js?render=${process.env.RECAPTCHA_INVISIBLE_KEY}`}
      async
    ></script>
    <script
      src="https://www.google.com/recaptcha/enterprise.js?render=explicit"
      async
      defer
    ></script>
  </Helmet>
)

export default RecaptchaScripts
